export const NOTIFICATION_RECEIVED = 'NOTIFICATION_RECEIVED';
